module.exports = __webpack_public_path__ + "media/PFS_PAI-v4_Aug_12_Digital.88397e74.mp4";